// @ts-ignore
import Cookies from 'js-cookie'

import rest from '../rest'
import cache from './cache'
import util from './util'

// token cookies 存贮命名
const TRACK_TOKEN_KEY = 'TRACK_TOKEN_KEY'
// 上报失败数据持久化 key
const EVENTS_CACHE_KEY = 'EVENTS_CACHE_KEY'
const RETRY_COUNT = 3 // 上报错误数据失败重试次数
const THRESHOLD = 20 // 一次最多上报20条埋点数据

let isUpLoading = false // 正在上报数据标识

// 获取 埋点事件上报 token
async function getEventTrackToken() {
  const token = Cookies.get(TRACK_TOKEN_KEY)
  if (token) {
    return token
  }
  const { code, data } = await (rest as any).common.getEventTrackToken()
  if (code !== 0) {
    return
  }
  // token 过期时间 300s
  Cookies.set(TRACK_TOKEN_KEY, data.Authorization, { expires: 290 / (60 * 60 * 24) })
  return data.Authorization
}

// 获取上报数据
function getEvents(report = []) {
  const eventsCacheData = cache.getLocalStorageData(EVENTS_CACHE_KEY) || []
  const reportLength = report.length
  if (!reportLength && !eventsCacheData.length) return []
  const events: any = [...report]
  // 上报数据长度小于阈值，从持久化数据中取出部分一起上报
  if (reportLength < THRESHOLD) {
    const cacheEvents = eventsCacheData.splice(0, THRESHOLD - reportLength)
    cache.setLocalStorageData(EVENTS_CACHE_KEY, eventsCacheData)
    events.push(...cacheEvents)
  }
  return events
}

// http 上报
async function reportEvents(events: []) {
  const token = await getEventTrackToken()
  const { code } = await (rest as any).common.postEventTrack({ headers: { Authorization: token } })({ events })
  if (code === 401 || code === 403) {
    // 401 -> token过期, 403 -> 非法token
    Cookies.set(TRACK_TOKEN_KEY, '', -1)
  }
  return code === 0
}

// 上报失败进行重试
// 重试 n 次，如 n 次均上报失败，则丢弃这组数据
async function retryReportEvents(events: []) {
  for (let i = 0; i < RETRY_COUNT; i++) {
    // eslint-disable-next-line no-await-in-loop
    const result = await reportEvents(events)
    if (result) break
  }
}

async function uploadReport(report = []) {
  const events = getEvents(report)
  if (!events.length) {
    return
  }
  isUpLoading = true
  const firstUpload = await reportEvents(events)
  // 首次上报失败进行重试
  if (!firstUpload) {
    await retryReportEvents(events)
  }
  isUpLoading = false
  // 上报剩余持久化数据
  uploadReport([])
}

//  处理埋点数据
export async function traceEventsReport(eventCode: string, params: any) {
  const token = await getEventTrackToken()
  const events = params.map((param: any) => {
    const happen_at = util.formatTime(new Date(), 'yyyy-MM-dd hh:mm:ss')
    return { ...param, happen_at, event_code: eventCode }
  })
  const eventsCacheData = cache.getLocalStorageData(EVENTS_CACHE_KEY) || []
  if (!token || isUpLoading) {
    // 未获取到 token (请求获取失败), 或正在上报数据时 将埋点数据持久化
    cache.setLocalStorageData(EVENTS_CACHE_KEY, [...eventsCacheData, ...events])
    return
  }
  // 上报数据条数超过阈值，对超出的数据持久化
  if (events.length > THRESHOLD) {
    const exceed = events.splice(THRESHOLD)
    cache.setLocalStorageData(EVENTS_CACHE_KEY, [...eventsCacheData, ...exceed])
  }
  // 数据上报
  uploadReport(events)
}

/**
 * 埋点上报装饰器
 * @param eventCode 事件编码/events数组
 * @param fn 自定义上报参数，需要返回额外对象。
 * @param isContinue
 * @returns {function(*, *, *): *}
 */
// @ts-ignore
export function traceLog(eventCode, fn = (...arg) => [], isContinue = (...arg) => true) {
  // @ts-ignore
  return function (target, key, descriptor) {
    const oldFn = descriptor.value
    // @ts-ignore
    descriptor.value = function (...args) {
      try {
        isContinue(this, ...args) && traceEventsReport(eventCode, fn(this, ...args))
      } catch (e) {
        // TODO：后面上报 sentry
      }
      oldFn.apply(this, args)
    }
    return descriptor
  }
}
